import ApiManager from '../../../services/apiManager';
import AiChatBotEndpoint from './AiChatBotApiEndpoint';
import headerService from '../../../services/header.service';
import useLocalStorage from '../../../utils/localStorage';
import chatEndpoints from '../AIChatBotQuestions/Chat.endpoints';

export const getRecommendationList = async (requestData) => {
	try {
		await ApiManager.post(
			AiChatBotEndpoint.getQuestionSuggestionList(requestData),
			true,
			false,
			true
		)
			.then((response) => {
				const suggestionData = {
					type: 'setSuggestionList',
					data: response.data.suggestions,
				};
				const suggestionList = {
					type: 'isSuggestionListPresent',
					data: true,
				};
				headerService.emit(suggestionList);
				headerService.emit(suggestionData);
			})
			.catch((error) => {
				console.log(error, '<<< Recommendation Api Failure >>>');
			});
	} catch (error) {
		console.log('<<< Recommendation List Failure >>>' + error);
	}
};
  
export const getAnswer = async (requestBody, question, job_id) => {
    const requestBodyy = { job_id };

    try {
        const response = await ApiManager.get(
            AiChatBotEndpoint.getFinalAnswer({ requestBodyy }),
            true
        );
        if(response.status === 'completed'){
			const apiResponse = {
				type: 'diggiChatresponseFromApi',
				data: {
					...response?.result,
					question,
					fromPagination: requestBody?.fromPagination || false,
                    showLink: Boolean(requestBody?.fromPagination)
				}
			};
	
			headerService.emit(apiResponse);
	
			// Hide suggestions
			headerService.emit({
				type: 'isSuggestionListPresent',
				data: false
			});
	
			// Add question to recent list
			headerService.emit({
				type: 'addNewRecentQuestion',
				data: {
					question: question?.question || question,
					data_source: requestBody?.requestBody?.datasource,
					qid: response?.data?.qid
				}
			});
	
			// Enable text field after response
			headerService.emit({
				type: 'disableNewQuestion',
				data: false
			});
	
			return response;
		}
		return response;
      
    } catch (error) {
        const apiResponse = {
            type: 'diggiChatresponseFromApi',
            data: {
                ...(error?.data || {}),
                question,
                fromPagination: requestBody?.fromPagination || false
            }
        };

        headerService.emit(apiResponse);

        // Ensure suggestion list hides on error too
        headerService.emit({
            type: 'isSuggestionListPresent',
            data: false
        });

        // Re-enable text field even on error
        headerService.emit({
            type: 'disableNewQuestion',
            data: false
        });

        return error;
    }
};

export const getQuestionAnswer = async (requestBody, question) => {
    try {

        // Step 1 — Hit ask API → get jobId
        const response = await getQuestionIdAndThreadId(requestBody);

        if (!response) {
            console.log("<<< jobId not found >>>");
            return;
        }

        // Step 2 — Start polling until completed
        await pollStatusUntilDone(requestBody, question,response.job_id);
        const activeThreadId = localStorage.getItem("active_thread_id");

         if (!activeThreadId && response.thread_id) {
             useLocalStorage.setItem('active_thread_id',response.thread_id);
            return response.thread_id;

             }

        // Step 3 — When completed → call getAnswer
        // await getAnswer(requestBody, question, jobId);

    } catch (error) {
        console.log("<<< Error in getQuestionAnswer >>>", error);
    }
};

export const getQuestionIdAndThreadId = async (requestData) => {
    try {
        const response = await ApiManager.post(
            AiChatBotEndpoint.askDiggChatBot(requestData),
            true
        );

        return response;
        
    } catch (error) {
        console.log(error, "<<< Status API Failure >>>");
        return { status: "error" };
    }
};

const pollStatusUntilDone = async (requestBody, question, jobId) => {
    const FIRST_DELAY = 3000;   // 3 sec initial delay
    const POLL_INTERVAL = 10000; // 10 sec interval
    const MAX_ATTEMPTS = 300;
    let attempts = 0;

    return new Promise((resolve, reject) => {

        // 🔥 First check after 3 seconds
        setTimeout(async () => {
            try {
                const initialStatus = await getAnswer(requestBody, question, jobId);
                console.log("Initial Status:", initialStatus?.status);

                if (initialStatus?.status === "completed") {
                    return resolve(true);
                }
            } catch (err) {
                console.log("Initial getAnswer error:", err);
            }

            // ⏳ Start 10-sec interval polling
            const interval = setInterval(async () => {
                attempts++;

                try {
                    const statusRes = await getAnswer(requestBody, question, jobId);
                    console.log("Polling Status:", statusRes?.status);

                    if (statusRes?.status === "completed") {
                        clearInterval(interval);
                        return resolve(true);
                    }

                    if (attempts > MAX_ATTEMPTS) {
                        clearInterval(interval);
                        return reject("Polling timeout reached");
                    }

                } catch (err) {
                    console.log("Polling error:", err);
                }

            }, POLL_INTERVAL);

        }, FIRST_DELAY);
    });
};

export const getQuestionHistory = async () => {
	try {
		try {
			let request = {
				limit: 1,
				offset: 10,
			};
			await ApiManager.post(AiChatBotEndpoint.getQuestionHistory(request), true)
				.then((response) => {
					const questionHistory = {
						type: 'historyQuestions',
						data: response.data,
					};
					const trendingQuestions = {
						type: 'trendingQuestions',
						data: response.data.df_faq,
					};
					headerService.emit(trendingQuestions);
					headerService.emit(questionHistory);
				})
				.catch(() => {});
		} catch (error) {
			console.log('<<< Errow While Api Hit (diggichat/history) >>>' + error);
		}
	} catch (error) {
		console.log('<<< Error While Question History >>>' + error);
	}
};
